import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c075027"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-table-ext" }
const _hoisted_2 = {
  key: 0,
  class: "el-table-ext__panel"
}
const _hoisted_3 = {
  key: 0,
  class: "el-table-ext__table-wrap"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "el-table-ext__table-footer" }
const _hoisted_6 = {
  key: 1,
  class: "el-table-ext__empty"
}
const _hoisted_7 = { class: "el-table-ext__placeholder" }
const _hoisted_8 = { class: "el-table-ext__table-footer is-empty" }
const _hoisted_9 = {
  key: 0,
  class: "el-table-ext__search"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "el-table-ext__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRecordDisplay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.selectedRecord)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_el_table, {
                  data: _ctx.selectedRecordList,
                  border: "",
                  size: "mini",
                  class: "el-table-ext__preview-table",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effectiveDisplayColumns, (col, index) => {
                      return (_openBlock(), _createBlock(_component_el_table_column, {
                        key: index,
                        prop: col.prop,
                        label: col.label || col.prop,
                        width: col.width,
                        "min-width": col.minWidth || (col.type === 'avatar' || col.type === 'image' ? 70 : 120),
                        align: "center",
                        "show-overflow-tooltip": col.type !== 'avatar' && col.type !== 'image'
                      }, _createSlots({ _: 2 }, [
                        (col.type === 'avatar' || col.type === 'image')
                          ? {
                              name: "default",
                              fn: _withCtx((scope) => [
                                (scope.row[col.prop])
                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                      key: 0,
                                      src: scope.row[col.prop],
                                      "preview-src-list": [scope.row[col.prop]],
                                      style: _normalizeStyle({
                  width: (col.imgSize || 28) + 'px',
                  height: (col.imgSize || 28) + 'px',
                  borderRadius: col.type === 'avatar' ? '50%' : '4px',
                  verticalAlign: 'middle'
                }),
                                      fit: "cover"
                                    }, null, 8, ["src", "preview-src-list", "style"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["prop", "label", "width", "min-width", "show-overflow-tooltip"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "mini",
                    onClick: _ctx.openDialog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("选择")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.clearable)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "mini",
                        onClick: _ctx.handleClear
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("清空")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.placeholder), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "mini",
                    onClick: _ctx.openDialog
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("选择")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
        ]))
      : (_openBlock(), _createBlock(_component_el_input, {
          key: 1,
          "model-value": _ctx.displayValue,
          placeholder: _ctx.placeholder,
          readonly: "",
          clearable: _ctx.clearable,
          onClear: _ctx.handleClear
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, { onClick: _ctx.openDialog }, {
              default: _withCtx(() => [
                _createTextVNode("选择")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["model-value", "placeholder", "clearable", "onClear"])),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: _ctx.dialogTitle,
      width: "70%",
      "destroy-on-close": "",
      "append-to-body": "",
      onOpen: _ctx.handleDialogOpen,
      onClosed: _ctx.handleDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.searchColumns.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_form, {
                inline: true,
                model: _ctx.searchForm,
                "label-width": "90px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchColumns, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: index,
                      label: item.label
                    }, {
                      default: _withCtx(() => [
                        (item.type === 'daterange' || item.type === 'datetimerange')
                          ? (_openBlock(), _createBlock(_component_el_date_picker, {
                              key: 0,
                              modelValue: _ctx.searchForm[item.prop],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.searchForm[item.prop]) = $event),
                              type: item.type,
                              "value-format": item.valueFormat || (item.type === 'datetimerange' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'),
                              "start-placeholder": item.startPlaceholder || '开始时间',
                              "end-placeholder": item.endPlaceholder || '结束时间',
                              style: _normalizeStyle({ width: item.width || '260px' }),
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "value-format", "start-placeholder", "end-placeholder", "style"]))
                          : (_openBlock(), _createBlock(_component_el_input, {
                              key: 1,
                              modelValue: _ctx.searchForm[item.prop],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.searchForm[item.prop]) = $event),
                              placeholder: item.placeholder || `请输入${item.label || ''}`,
                              style: _normalizeStyle({ width: item.width || '180px' }),
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "style"]))
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { onClick: _ctx.handleSearchReset }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.handleSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("搜索")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "dialogTableRef",
          data: _ctx.tableData,
          stripe: "",
          border: "",
          "highlight-current-row": "",
          style: {"width":"100%"},
          onCurrentChange: _ctx.handleCurrentRowChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, index) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: index,
                prop: col.prop,
                label: col.label,
                width: col.width,
                "min-width": col.minWidth,
                align: "center",
                "show-overflow-tooltip": col.type !== 'avatar' && col.type !== 'image'
              }, _createSlots({ _: 2 }, [
                (col.type === 'avatar' || col.type === 'image')
                  ? {
                      name: "default",
                      fn: _withCtx((scope) => [
                        (scope.row[col.prop])
                          ? (_openBlock(), _createBlock(_component_el_image, {
                              key: 0,
                              src: scope.row[col.prop],
                              "preview-src-list": [scope.row[col.prop]],
                              style: _normalizeStyle({
                width: (col.imgSize || 40) + 'px',
                height: (col.imgSize || 40) + 'px',
                borderRadius: col.type === 'avatar' ? '50%' : '4px'
              }),
                              fit: "cover"
                            }, null, 8, ["src", "preview-src-list", "style"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["prop", "label", "width", "min-width", "show-overflow-tooltip"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["data", "onCurrentChange"])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_pagination, {
            "current-page": _ctx.pageNo,
            "page-sizes": [10, 20, 30, 50],
            "page-size": _ctx.pageSize,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _ctx.total,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handlePageChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title", "onOpen", "onClosed"])
  ]))
}